module.exports = __webpack_public_path__ + "static/media/joni.990e8200.png";


//////////////////
// WEBPACK FOOTER
// ./src/joni.png
// module id = 180
// module chunks = 0